import type { LoaderFunctionArgs } from "@remix-run/node"
import { json } from "@remix-run/node"
import Header from "~/components/header"
import Typography from "~/components/typography"
import { Public } from "~/utils/remix"
import showdown from "showdown"
import { Link, useLoaderData, useNavigate } from "@remix-run/react"
import options1 from "~/assets/merch/2-1.webp"
import options2 from "~/assets/merch/2-2.webp"
import options3 from "~/assets/merch/2-3.webp"
import options4 from "~/assets/merch/2-4.webp"
import bookCover from "~/assets/homepage/book.webp"
import { MetaFunction } from "@remix-run/node"
import { Button } from "~/components/ui/button"
import type { UserPayment } from "@prisma/client"
import { useState } from "react"
import { Purchase } from "~/components/purchase"
import { ShoppingBlock, ShoppingBlockHorizontal } from "~/components/cards"

export const meta: MetaFunction = () => {
  return [
    { title: "Show You're Good In Bed" },
    { property: "og:title", content: "Show You're Good In Bed" },
    {
      name: "description",
      content:
        "Do you want to support the Social Sex Revolution, and tell the world you have great sexual values? Browse our merch collection here to really show you're good in bed.",
    },
  ]
}

export const loader = Public(async ({ request, context }: LoaderFunctionArgs) => {
  const converter = new showdown.Converter()
  let cards: UserPayment[] = []

  if (context.user) {
    cards = await context.db.userPayment.findMany({
      where: { UserID: context.user.UserID, CardStatus: 1, Deleted: 0 },
    })
  }

  const pkg = await context.db.packages.findFirst({
    where: { Tag: { in: ["ted-book"] } },
  })

  return json({
    user: context.user,
    cards,
    pkg,
  })
})

export default function Merch() {
  const data = useLoaderData<typeof loader>()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [purchaseID, setPurchaseID] = useState<number>(0)

  function startPurchase() {
    if (!data.user) {
      navigate("/login?redirectTo=/book")
    }
    setOpen(true)
  }

  function purchased(purchase: PurchaseWithPackage) {
    setPurchaseID(Number(purchase.PurchaseID))
  }


  return (
    <div className="max-w-5xl m-auto mt-16">
      <Header title="MakeLoveNotPorn Merchandise" />
      <div className="mx-4 md:mx-16">
        <Typography className="max-w-none">
          <p>Tell the world you love to make love, not porn!</p>
          <p>Because when you're a member of our amazing community, what that says about you is… </p>
          <div className="bg-card-secondary rounded-xl p-8 my-8 text-center">
            <h2 className="mt-4">"I'm good in bed the way it really counts – the real world sex way. I stand for good sexual values and good sexual behavior."</h2>
          </div>
          <p>Who wouldn't want the world to know that?!</p>
        </Typography>
        <div className="mx-2 my-8 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 ">
          <ShoppingBlock
            title="MakeLoveNotPorn Heart T-Shirt"
            image={options1}
            imageAlt="MakeLoveNotPorn Heart T-Shirt"
            shopUrl="https://www.teepublic.com/t-shirt/5868831-mlnp-heart?store_id=239496"
          />
          <ShoppingBlock
            title="I'm a MakeLoveNotPornstar T-Shirt"
            image={options3}
            imageAlt="I'm a MakeLoveNotPornstar T-Shirt"
            shopUrl="https://www.teepublic.com/t-shirt/6119432-im-a-makelovenotpornstar?store_id=239496"
          />
          <ShoppingBlock
            title="Join the Social Sex Revolution Hoodie"
            image={options2}
            imageAlt="join the social sex revolution hoodie"
            shopUrl="https://www.teepublic.com/hoodie/6704207-join-the-social-sex-revolution"
          />
          <ShoppingBlock
            title="Join the Social Sex Revolution Mug"
            image={options4}
            imageAlt="join the social sex revolution mug"
            shopUrl="https://www.teepublic.com/mug/6704207-join-the-social-sex-revolution"
          />
        </div>
        <ShoppingBlockHorizontal
          title="Read Cindy's Book from TED"
          image={bookCover} 
          imageAlt="Cindy Gallop's Revelations"
          description="Technology's Hardcore Impact On Human Behavior"
          className="my-8"
          onShopClick={startPurchase}
          buttonText="Buy Now"
        />
        <Typography>
          <p>Each of these MakeLoveNotPorn designs is available in a variety of t-shirts, hoodies, mugs, phone cases, stickers and more!</p>
          <p>Select your favorite design and explore the merchandise options.</p>
        </Typography>
        <div className="flex my-6">
          <Button 
            className="text-xl tracking-wide px-6 py-8"
            variant="default"
            size="lg"
            onClick={() => window.open("https://www.teepublic.com/user/makelovenotporn", "_blank")}>
            Browse All Designs &raquo;
          </Button>
        </div>
        <div className="mx-4 md:mx-16">
          <Purchase
            pkg={data.pkg}
            cards={data.cards}
            open={open}
            setOpen={setOpen}
            setPurchase={purchased}
            description="Receive downloadable PDF of Cindy Gallop's Revelations"
            successMsg={
              <div className="text-center">
                <Typography>
                  <h2 className="text-lg font-semibold leading-none tracking-tight mb-2">Download PDF</h2>
                  <p className="text-xs mb-8">
                    You can find the download link in the future in the <Link to="/billing">billing area</Link> of your
                    account.
                  </p>
                </Typography>
                <Link to={`/book.pdf?purchaseID=${purchaseID}`} target="_blank">
                  <Button className="text-lg tracking-wide p-4">Download</Button>
                </Link>
              </div>
            }
          />
        </div>
      </div>
    </div>
  )
}
